// extracted by mini-css-extract-plugin
module.exports = {"componentBBHero":"bb-hero__0mMvh","bb-hero-image":"bb-hero-image__ZWa7E"};